import React, { Component } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import { RedirectAdmin } from "./components/redirect";
import { baseStyles } from "./components/styled/global/index";
import { defaultMunicipality } from "./config/subDomain";
import { Municipality, PageNotFound } from "./pages";
import { getMun, getMunData } from "./utils";
import {
  isSegregated,
  getMunicipalityFromUrl,
  getIsSegregatedFromEnv,
} from "./utils/core-helpers";

const appIsSegregated = getIsSegregatedFromEnv();
const currentMunicipalityKey = getMunicipalityFromUrl();

let basename;
if (appIsSegregated) {
  basename = "";
} else {
  basename = `/${currentMunicipalityKey}`;
}

const municipality = getMun();
const subDomainData = getMunData();

class Router extends Component {
  render() {
    baseStyles();
    console.log("App Is Segregated:", appIsSegregated);
    console.log("Current Municipality Key:", currentMunicipalityKey);
    console.log("BrowserRouter Basename:", basename);

    return (
      <BrowserRouter basename={basename}>
        <div>
          <Switch>
            <Route exact path='/login' component={RedirectAdmin} />
            <Route exact path='/admin' component={RedirectAdmin} />

            {subDomainData.title && (
              <Route
                exact
                path='/'
                render={(props) => (
                  <Municipality {...props} municipality={subDomainData} />
                )}
              />
            )}

            <Route
              path='*'
              render={(props) => <PageNotFound isMainPage {...props} />}
            />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default Router;



// WEBPACK FOOTER //
// ./src/router.js